import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../styles/custom.css";
import heroImg from '../assets/img/hero-img.webp';
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const { t } = useTranslation();
  return (
    <section className="hero-section d-flex align-items-center mt-4">
      <Container>
        <Row className="align-items-center">
          <Col md={6}>
            <p className="subtitle text-start">{t('The pharmacy you are looking for')}</p>
            <h1 className="title text-start display-2 fw-bold">
              {t('Your Health')},<br />
              <span style={{ color: '#39d0bd' }}>{t('Our Priority')}</span>
            </h1>
            <p className="description text-start mt-3 fs-5">
              {t('Connect with certified pharmacies nationwide. Get your prescriptions filled, consult with licensed pharmacists, and access healthcare services with confidence.')}
            </p>
          </Col>

          <Col md={6} className="position-relative d-none d-md-block">
            {/* Added width and height to prevent layout shift */}
            <img
              src={heroImg}
              lazy="true"
              alt="Hero"
              className="img-fluid hero-image"
              width="450"
              height="400"
              loading="eager"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
